var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowSort = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrow_sort_svg__a{fill:none}.arrow_sort_svg__b{fill:#d1d0d0}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow_sort_svg__a",
    d: "M24 0v24H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-sort-arrow": "descending",
    className: "arrow_sort_svg__b",
    d: "M18 15l-1.41-1.41L12 18.17l-4.59-4.58L6 15l6 6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-sort-arrow": "ascending",
    className: "arrow_sort_svg__b",
    d: "M16.59 10.41L18 9l-6-6-6 6 1.41 1.41L12 5.83z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowSort);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_sort.a0688b3c82be7037095fa19b48cff481.svg";